import {
    SalesRevenueByCompanyAllListElementType,
    SalesRevenueByCompanyAllMapType,
    SalesRevenueByCompanyAllType,
    SalesRevenueByCompanyMapType,
    SalesRevenueByCompanyType,
    SalesRevenueViewInfoElementType,
    SalesSearchParamType,
    SalesYearlyMapSummaryType,
    SalesYearlyMapType
} from "../interface";
import moment from "moment";

export const salesSearchParamInit: SalesSearchParamType = {
    handlerId: 0,
    limit: 10,
    pageNo: 1,
    revenueMonth: moment().month() + 1,
    revenueYear: moment().year(),
    teamId: ""
}

export const salesYearlyMapSummaryInit: SalesYearlyMapSummaryType = {
    achievementRevenueRate: 0,
    actualRevenue: 0,
    estimatedRevenue: 0,
    estimatedRevenueRate: 0,
    revenueGoal: 0,
    summaryType: ""
}

export const salesYearlyMapInit: SalesYearlyMapType = {
    firstHalfData: {
        firstQuarterData: {
            firstMonthData: {
                monthSummaryList: []
            },
            secondMonthData: {
                monthSummaryList: []
            },
            thirdMonthData: {
                monthSummaryList: []
            },
            quarterSummary: salesYearlyMapSummaryInit
        },
        secondQuarterData: {
            firstMonthData: {
                monthSummaryList: []
            },
            secondMonthData: {
                monthSummaryList: []
            },
            thirdMonthData: {
                monthSummaryList: []
            },
            quarterSummary: salesYearlyMapSummaryInit
        },
        halfSummary: salesYearlyMapSummaryInit
    },
    secondHalfData: {
        firstQuarterData: {
            firstMonthData: {
                monthSummaryList: []
            },
            secondMonthData: {
                monthSummaryList: []
            },
            thirdMonthData: {
                monthSummaryList: []
            },
            quarterSummary: salesYearlyMapSummaryInit
        },
        secondQuarterData: {
            firstMonthData: {
                monthSummaryList: []
            },
            secondMonthData: {
                monthSummaryList: []
            },
            thirdMonthData: {
                monthSummaryList: []
            },
            quarterSummary: salesYearlyMapSummaryInit
        },
        halfSummary: salesYearlyMapSummaryInit
    },
    yearlySummary: salesYearlyMapSummaryInit
}

export const salesRevenueByCompanyInit: SalesRevenueByCompanyType = {
    revenueId: 0,
    handlerId: 0,
    shipErpAccountId: "",
    customerAccountsId: "",
    revenueErpAccountId: "",
    newProductGroupid: "",
    revenueYear: 0,
    revenueMonth: 0,
    revenueGoal: 0,
    estimatedRevenue: 0,
    actualRevenue: 0,
    modAt: "",
    regAt: "",
    deleteFlag: "N",
    teamId: "",
    handlerName: "",
    vendor: "",
    category: "",
    shipErpAccountName: "",
    customerAccountsName: "",
    revenueErpAccountName: "",
};

export const salesRevenueViewInfoElementInit: SalesRevenueViewInfoElementType = {
    revenueViewInfoId: 0,
    target: "",
    isHidden: "N",
    deleteFlag: "N",
};

export const salesRevenueByCompanyMapInit: SalesRevenueByCompanyMapType = {
    revenueVOList: [],
    revenueViewInfoVOList: [],
};

export const salesRevenueByCompanyAllMapInit: SalesRevenueByCompanyAllMapType = {
    searchAllRevenueResList: [],
    revenueViewInfoVOList: [],
};

export const salesRevenueByCompanyAllListElementInit: SalesRevenueByCompanyAllListElementType = {
    revenueData: {
        revenueGoal: 0,
        estimatedRevenue: 0,
        actualRevenue: 0,
    },
    month: 0
}

export const salesRevenueByCompanyAllInit: SalesRevenueByCompanyAllType = {
    handlerName: "",
    handlerId: "",
    shipErpAccountName: "",
    customerAccountsName: "",
    revenueErpAccountName: "",
    vendor: "",
    category: "",
    vendorName: "",
    categoryName: "",
    shipErpAccountId: "",
    revenueErpAccountId: "",
    newProductGroupid: "",
    customerAccountsId: "",
    revenueId: 0,
    revenueDataMapList: [
        {...salesRevenueByCompanyAllListElementInit, month: 1},
        {...salesRevenueByCompanyAllListElementInit, month: 2},
        {...salesRevenueByCompanyAllListElementInit, month: 3},
        {...salesRevenueByCompanyAllListElementInit, month: 4},
        {...salesRevenueByCompanyAllListElementInit, month: 5},
        {...salesRevenueByCompanyAllListElementInit, month: 6},
        {...salesRevenueByCompanyAllListElementInit, month: 7},
        {...salesRevenueByCompanyAllListElementInit, month: 8},
        {...salesRevenueByCompanyAllListElementInit, month: 9},
        {...salesRevenueByCompanyAllListElementInit, month: 10},
        {...salesRevenueByCompanyAllListElementInit, month: 11},
        {...salesRevenueByCompanyAllListElementInit, month: 12},
    ]
}